import React from 'react'

const AutomationOptionsNotification = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="37" height="45" viewBox="0 0 37 45" fill="none" className={className}>
    <path
      d="M22.4103 40.22C22.3395 41.2112 21.8957 42.1389 21.1684 42.8161C20.441 43.4933 19.4841 43.8698 18.4903 43.8698C17.4965 43.8698 16.5396 43.4933 15.8123 42.8161C15.0849 42.1389 14.6412 41.2112 14.5703 40.22"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M35.2804 31.84L32.4904 28.03C31.5285 26.7095 30.9006 25.1759 30.6604 23.56L29.2904 14.67C29.2922 12.3489 28.5476 10.0887 27.1665 8.22317C25.7854 6.35766 23.841 4.98574 21.6204 4.31C21.5942 3.47081 21.2611 2.67038 20.6842 2.06034C20.1074 1.4503 19.3268 1.07303 18.4904 1C17.6486 1.06604 16.8607 1.44025 16.2777 2.05098C15.6946 2.66172 15.3573 3.46606 15.3304 4.31C13.1098 4.98574 11.1654 6.35766 9.78424 8.22317C8.40312 10.0887 7.65851 12.3489 7.66037 14.67V14.67L6.29037 23.56C6.05904 25.1732 5.44153 26.7067 4.49037 28.03L1.70037 31.84C1.32469 32.3574 1.09068 32.9639 1.02153 33.5995C0.952378 34.2351 1.05048 34.8777 1.30611 35.4638C1.56174 36.0498 1.96604 36.5589 2.47895 36.9406C2.99187 37.3223 3.59561 37.5634 4.23037 37.64C8.96621 38.1511 13.7271 38.3948 18.4904 38.37C23.2538 38.3915 28.0147 38.1444 32.7504 37.63C33.3835 37.5524 33.9854 37.3112 34.4969 36.9301C35.0083 36.549 35.4117 36.0412 35.667 35.4567C35.9224 34.8722 36.0211 34.2313 35.9533 33.5971C35.8855 32.9629 35.6536 32.3573 35.2804 31.84V31.84Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
)

export default AutomationOptionsNotification
